
import { Base } from '@studiometa/js-toolkit';

export default class HeaderSearch extends Base {
  static config = {
    name: 'HeaderSearch',
    refs: ['opener'],
    emits: ['show-search'],
    log: true,
  };

  mounted() {
   console.log('mounted');

  }

  onOpenerClick() {
    this.$log('show-search');
    this.$emit('show-search');
  }
}
